import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: unknown) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="min-h-screen bg-graphite mechanical-grid flex items-center justify-center px-4">
          <div className="tech-card p-8 max-w-2xl w-full">
            <div className="text-center">
              <i className="ri-error-warning-line text-6xl text-accent-orange mb-4"></i>
              <h1 className="text-2xl font-bold text-white font-['Exo'] mb-4">
                ページの読み込みに失敗しました
              </h1>
              <p className="text-metal-light mb-6">
                申し訳ございません。ページの表示中にエラーが発生しました。
              </p>
              <div className="flex gap-4 justify-center">
                <button
                  onClick={() => window.location.reload()}
                  className="px-6 py-2 bg-accent hover:bg-accent/80 text-graphite font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                >
                  ページを再読み込み
                </button>
                <a
                  href="/"
                  className="px-6 py-2 bg-metal hover:bg-metal-light text-white font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  ホームに戻る
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
